import React, { useEffect, useState } from "react";
import { stylize } from "@envestnet/envreact-component-library";
import { Redirect, Route, Switch } from "react-router-dom";
import withIntl from "utils/withIntl";

import styles, { Styles } from "./styles";
import { UserDetails, UserInfo } from "types/UserInfo";
import DashboardContainer from "components/DashboardContainer";
import DashboardHome from "scenes/DashboardHome";
import DashboardSecuritySettings from "scenes/DashboardSecuritySettings";
import MfaUpdate from "scenes/DashboardMfa";
import EditPassword from "scenes/EditPassword";
import EnvAuthenticator from "scenes/EnvAuthenticator";
import EditUsername from "scenes/EditUsername";
import EmailAuthenticator from "scenes/EmailAuthenticator";
import storage from "persistance";

interface InjectedProps extends Styles {
  /** Internal - injected from withIntl */
  formatMessage: FormatMessage;

  /** Internal - injected from WithStyles */
  innerRef?: React.RefObject<HTMLDivElement>;

  removeToken: () => void;
  getTnCForCidpUser: () => void;
  setUserAcceptedNewTnC: () => void;
  goToSecuritySettings: () => void;
  logout: () => void;

  userInfo: UserInfo;
  userDetails: UserDetails;
  hasUpdatedTnCAccepted: boolean;
  tncForCidpUser: string | null;
}

interface DefaultProps {}

export interface DashboardLayoutProps extends DefaultProps {
  /** CSS class name to be applied to top level component */
  className?: string;

  /** Inline style object to be applied to top level component */
  style?: React.CSSProperties;
}

const defaultProps: DefaultProps = {};

type Props = InjectedProps & DashboardLayoutProps;

const DashboardLayout = (props: Props) => {
  const {
    userInfo,
    userDetails,
    logout,
    hasUpdatedTnCAccepted,
    tncForCidpUser,
    getTnCForCidpUser,
    setUserAcceptedNewTnC,
    goToSecuritySettings,
  } = props;

  const [dashboardLoading, setDashboardLoading] = useState<boolean>(false);

  useEffect(() => {
    if ((userInfo as UserInfo).email !== "") {
      getTnCForCidpUser();
    }
  }, [userInfo]);

  return (
    <DashboardContainer
      goToSecuritySettings={goToSecuritySettings}
      logout={() => {
        storage.removeItem("emailOtpResendCount");
        logout();
      }}
      user={userInfo}
      isDirectLoginEnabled={userDetails.directLoginEnabled}
      setUserAcceptedNewTnC={setUserAcceptedNewTnC}
      hasUpdatedTnCAccepted={hasUpdatedTnCAccepted}
      tncForCidpUser={tncForCidpUser}
      loadingDashboard={dashboardLoading}
    >
      <Switch>
        <Route
          exact
          path="/dashboard/securitysettings/edit-password"
          component={EditPassword}
        />
        <Route
          exact
          path="/dashboard/securitysettings/edit-username"
          component={EditUsername}
        />
        <Route
          exact
          path="/dashboard/securitysettings"
          component={DashboardSecuritySettings}
        />
        <Route exact path="/dashboard/mfa" component={MfaUpdate} />
        <Route
          exact
          path="/dashboard/home"
          render={(routeProps) => (
            <DashboardHome
              {...routeProps}
              setDashboardLoading={setDashboardLoading}
            />
          )}
        />
        <Route
          exact
          path="/dashboard/env-auth-verify"
          component={EnvAuthenticator}
        />

        <Route
          exact
          path="/dashboard/email-otp"
          component={EmailAuthenticator}
        />

        <Route
          exact
          path="/dashboard"
          render={({ location }) => (
            <Redirect
              to={{
                pathname: "/dashboard/home",
                search: location.search,
              }}
            />
          )}
        />
      </Switch>
    </DashboardContainer>
  );
};

DashboardLayout.defaultProps = defaultProps;

export default withIntl(stylize<Props, DefaultProps>(styles)(DashboardLayout));
